import {
  Box,
  Button,
  FormControl,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import {
  APP_COLOR,
  ENTERPRISE_IMAGE_PATH,
  TEXT_COLOR,
  THEME,
  isEnterprise,
} from "../../theme";
import logo from "../../components/ResponsiveNavbar/logo.png";
import { preferencesStageStyles, useStyles } from "./styles";
import { SelectField } from "../../pages/ProfileSettings/styles";
import { GenresArray, SkillsArray } from "../constants";
import CheckIcon from "@mui/icons-material/Check";
import React from "react";
import { PreferencesStageProps } from "./types";
import { styles } from "../../pages/InitialSettings/styles";
import { CustomCircularProgress } from "../ProgressComponents/CustomCircularProgress";

export const PreferencesStage: React.FC<PreferencesStageProps> = ({
  setSkills,
  setGenres,
  skills,
  genres,
  handleRegisterUser,
  setStage,
  isLoading,
}) => {
  const classes = useStyles();

  const handleChangeSkill = (
    _event: React.SyntheticEvent<Element, Event>,
    value: unknown
  ) => {
    const tempSkillsArr: string[] = [];
    const values = value as Array<string>;
    const length = values.length;
    for (let i = 0; i < length; i++) {
      const tag_curr = values[i];
      tempSkillsArr.push(tag_curr);
    }
    setSkills(tempSkillsArr);
  };

  const handleChangeGenre = (
    _event: React.SyntheticEvent<Element, Event>,
    value: unknown
  ) => {
    const tempGenreArr: string[] = [];
    const values = value as Array<string>;
    const length = values.length;
    for (let i = 0; i < length; i++) {
      const tag_curr = values[i];
      tempGenreArr.push(tag_curr);
    }
    setGenres(tempGenreArr);
  };

  return (
    <>
      <Box sx={preferencesStageStyles.mainContainer}>
        <Box sx={preferencesStageStyles.childOfMainComponent}>
          <Box
            sx={{
              ...styles.groupAddOutlinedIconContainer,
              color: TEXT_COLOR,
              borderColor: TEXT_COLOR,
            }}
          >
            <img
              src="/assets/icons/InitialSettingsIcons/users-plus.svg"
              style={{
                ...styles.groupAddOutlinedIcon,
                filter: THEME === "dark" ? "invert(100%)" : "invert(0%)",
              }}
              alt="icon"
            />
          </Box>
          <img
            style={preferencesStageStyles.logoImage}
            className="logo-image"
            src={isEnterprise ? ENTERPRISE_IMAGE_PATH : logo}
            alt="logo"
          />
          <Box sx={preferencesStageStyles.textFieldContainer}>
            <Typography sx={{ fontSize: "18px" }}>Skills</Typography>
            <FormControl fullWidth>
              {skills.length === 0 && (
                <InputLabel id="demo-simple-select-label">
                  Select skills
                </InputLabel>
              )}
              <SelectField
                multiple
                id="checkboxes-tags-demo"
                options={SkillsArray}
                disableCloseOnSelect
                fullWidth
                value={skills}
                onChange={(e, v) => handleChangeSkill(e, v)}
                renderOption={(props, option, { selected }) => (
                  <li
                    {...props}
                    style={preferencesStageStyles.list}
                    className={classes.customOption}
                  >
                    {option as string}
                    {selected && <CheckIcon style={{ color: APP_COLOR }} />}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    InputLabelProps={{ shrink: false }}
                    classes={{ root: classes.customTextField }}
                  />
                )}
              />
            </FormControl>
          </Box>
          <Box sx={preferencesStageStyles.textFieldContainer}>
            <Typography sx={{ fontSize: "18px" }}>Genre</Typography>
            <FormControl fullWidth>
              {genres.length === 0 && (
                <InputLabel id="demo-simple-select-label">
                  Select genre
                </InputLabel>
              )}
              <SelectField
                multiple
                value={genres}
                fullWidth
                id="checkboxes-tags-demo"
                options={GenresArray}
                disableCloseOnSelect
                onChange={(e, v) => handleChangeGenre(e, v)}
                renderOption={(props, option, { selected }) => (
                  <li
                    {...props}
                    style={preferencesStageStyles.list}
                    className={classes.customOption}
                  >
                    {option as string}
                    {selected && <CheckIcon style={{ color: APP_COLOR }} />}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    InputLabelProps={{ shrink: false }}
                    classes={{ root: classes.customTextField }}
                  />
                )}
              />
            </FormControl>
          </Box>
          <Box sx={preferencesStageStyles.buttonsContainer}>
            <Button
              onClick={() => {
                const isLastStep = true;
                handleRegisterUser(isLastStep);
              }}
              sx={preferencesStageStyles.button}
              fullWidth
            >
              {isLoading ? (
                <CustomCircularProgress size={22} customcolor="white" />
              ) : (
                "Next"
              )}
            </Button>
          </Box>
          <Box sx={preferencesStageStyles.buttonsContainer}>
            <Button
              onClick={() => {
                const isLastStep = true;
                handleRegisterUser(isLastStep);
              }}
              sx={preferencesStageStyles.skipButton}
              fullWidth
            >
              Skip
            </Button>
          </Box>
          <Box sx={preferencesStageStyles.indicatorContainer}>
            <Box
              onClick={() => setStage(0)}
              sx={preferencesStageStyles.indicatorDot}
            ></Box>
            <Box
              onClick={() => setStage(1)}
              sx={preferencesStageStyles.indicatorDot}
            ></Box>
            <Box
              onClick={() => setStage(2)}
              sx={{
                ...preferencesStageStyles.indicatorDot,
                backgroundColor: TEXT_COLOR,
              }}
            ></Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};
